var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M11.813 7.959a1.5 1.5 0 1 0-.002-3.001 1.5 1.5 0 0 0 .002 3zm15.187 18a1.5 1.5 0 0 1-1.5 1.5H24v-6a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v6H4.5a1.5 1.5 0 0 1-1.5-1.5V11.025c0-.2.08-.39.219-.53l2.78-2.78v1.744a3 3 0 0 0 3 3h12a3 3 0 0 0 3.001-3v-6h1.5a1.5 1.5 0 0 1 1.5 1.5zm-6 1.5H9v-4.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5zM9 4.714l1.255-1.255H21v4.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5zM27 .46H9.62c-.398 0-.779.157-1.06.44L.439 9.018A1.5 1.5 0 0 0 0 10.08v17.38c0 1.657 1.342 3 3 3h24a3 3 0 0 0 3-3v-24a3 3 0 0 0-3-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDesignIcon);
export default __webpack_public_path__ + "static/media/saveDesignIcon.ec6ea9022148dd6f397e845419332916.svg";
export { ForwardRef as ReactComponent };